module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; var rowWrite = function(row){
    _.each(row, function(value){ 
    ; __append("\n        <td class=\"center\">")
    ; __append(escapeFn(value))
    ; __append("</td>\n")
    ;     })
}
    ; __append("\n\n")
    ; 
var cellsWrite  = function(cols){
    _.each(cols, function (field) { 
    ; __append("\n        <th>")
    ; __append(escapeFn(field))
    ; __append("</th>\n")
    ;     })
}
 
    ; __append("\n<style>\n    .gl-report__table thead th {\n        text-align: center;\n    }\n    .gl-report__table .center {\n        text-align: center;\n    }\n\n    .gl-report__table tbody td,\n    .gl-report__table tbody th {\n        text-align: right;\n    }\n    .gl-report__table .left {\n        text-align: left;\n        float: inherit;\n    }\n</style>\n    <div class=\"wh100\">\n        <table class=\"gl-report__table width-regulator\">\n            <thead>\n            <tr>")
    ; cellsWrite(data.head.cols);
    ; __append("</tr>\n            </thead>\n\n            <tbody>\n            ")
    ;  _.each(data.rows, function (row) { 
    ; __append("\n                <tr>\n                    ")
    ;  rowWrite(row); 
    ; __append("\n                </tr>\n            ")
    ;  }); 
    ; __append("\n            </tbody>\n        </table>\n    </div>")
  }
  return __output.join("");

}